import { Ref } from 'preact';
import { useMemo } from 'preact/hooks';

export function useMergedRef(...refs: Ref<unknown>[]) {
  return useMemo(() => mergeRefs(...refs), refs);
}

function mergeRefs(...refs) {
  return (instance) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(instance);
      } else if (ref) {
        ref.current = instance;
      }
    }
  };
}
